import {Component, Input} from '@angular/core';
import {AgGridAngular} from 'ag-grid-angular';

import type { ColDef, GridOptions} from 'ag-grid-community';
import { ModuleRegistry} from 'ag-grid-community';
import { ClientSideRowModelModule } from 'ag-grid-community'


@Component({
  selector: 'app-product-list',
  imports: [
    AgGridAngular
  ],
  templateUrl: './product-list.html',
  styleUrl: './product-list.scss'
})
export class ProductList {

  // Row Data: The data to be displayed.
  @Input() rowData: any[] = [];

  gridOptions: GridOptions = {
    domLayout: 'autoHeight' as const,
    suppressHorizontalScroll: false,
    rowHeight: 24
  };

  defaultColDef: ColDef = {
    flex: 1,
    maxWidth: 800,
    minWidth: 100,
    resizable: true,
    sortable: true,
  };

  // Column Definitions: Defines the columns to be displayed.
  colDefs: ColDef[] = [
    { field: "brand" },
    { field: "title", width: 500 },
    { field: "capacity",
      valueFormatter: (p) => this.formatBytes(p.value),
    },
    { field: "interface" },
    { field: "price",
      valueFormatter: (p) => this.formatCurrency(p.value, p.data.currency),
      // cellStyle: { textAlign: 'center' },
      // headerClass: 'center-header',
    },
    { field: "type" },
    { field: "link",
      cellRenderer: (params: any) => {
        let displayText= '';

        if (params.value) {
          displayText= 'Visit Site';
          return `<a href="${params.value}" target="_blank" rel="noopener noreferrer">${displayText}</a>`;
        }
        return '';
      }
    }
  ];

  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }
  // Utility function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';
    if (bytes < 0) return 'Invalid';

    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));


    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  formatCurrency(value: number, currencyCode: string, locale: string = 'en-US'): string {
    if (value == null || value === undefined) return '';
    if (!currencyCode) return value.toString();

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return `${currencyCode} ${value.toFixed(2)}`;
    }
  }
}
